import { reducers } from '../store/index';
import * as CourseWorkbookActions from '../store/course-workbook/course-workbook.actions';
import { Injectable } from "@angular/core";
import { ActivatedRoute, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { select, Store } from "@ngrx/store";
import { filter, first, tap } from "rxjs/operators";
import * as selectors from "../store";

@Injectable()
export class AllCourseWorkbookResolver  {
  constructor(private store: Store<any>) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const courseId = route.params.courseId;
    return this.store.pipe(
      select(selectors.isCourseWorkbookLoaded, { id: courseId }),
      tap(isLoaded => {
        if (!isLoaded) {
          this.store.dispatch(new CourseWorkbookActions.GetAllCourseWorkbooks(courseId));
        }
      }),
      filter(isLoaded => !!isLoaded),
      first(),
    );
  }
}
